import React, { useState } from 'react';
import { Order } from '../../types/orderTypes';
import Dropdown from '../dropdownDeviation/Dropdown';
import './Deviation.scss';

type ReportDeviationProps = {
  order: Order;
  sendMessage: (order: Order, message: string, status: string) => void;
  showCourierDeviationWarning?: boolean;
};

export function ReportDeviation({
  order,
  sendMessage,
  showCourierDeviationWarning,
}: ReportDeviationProps): JSX.Element {
  const [deviationMessage, setDeviationMessage] = useState('');
  const [statusReq, setStatusReq] = useState('OPEN');
  const [loading, setLoading] = useState(false);
  const ddlItems = ['REGISTER DEVIATION', 'REGISTRER FIXED DEVIATION'];
  const ddlPlaceholder = statusReq === 'OPEN' ? ddlItems[0] : ddlItems[1];
  const btnText =
    statusReq === 'OPEN'
      ? 'CONFIRM DEVIATION'
      : 'CONFIRM THAT DEVIATION IS FIXED';

  const handleClick = () => {
    try {
      setLoading(true);
      sendMessage(order, deviationMessage, statusReq);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deviation-report-box">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div className="buttonPlacment">
          <Dropdown
            names={ddlItems}
            values={['OPEN', 'CLOSED']}
            placeholder={ddlPlaceholder}
            onChange={value => setStatusReq(value)}
          />
        </div>
      </div>

      <div className="deviation__input">
        <input
          type="text"
          placeholder={
            statusReq === 'OPEN'
              ? 'Write reason for deviation'
              : 'Write how deviation was fixed'
          }
          onChange={event => setDeviationMessage(event.target.value)}
        />
      </div>
      <div className="buttonPlacment">
        <button
          disabled={!deviationMessage.length || loading}
          onClick={handleClick}
        >
          {btnText}
        </button>
        {showCourierDeviationWarning && (
          <div className="deviation__courierwarning">
            If possible, use the new deviation system. It will automatically
            close this courier deviation.
          </div>
        )}
      </div>
    </div>
  );
}
